import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Route, Switch } from 'react-router-dom';
import ErrorDialog from '../components/ErrorDialog';
import LeftDrawer from '../components/LeftDrawer';
import SuccessDialog from '../components/SuccessDialog';
import LayoutContainer from '../containers/Layout';

//- Pages / Route
import AddNotificationJob from './AddNotificationJob';
import Blends from './Blends';
import Dashboard from './Dashboard';
import ExternalLogisticsDashboard from './ExternalLogisticsDashboard';
import ExternalReportingDashboard from './ExternalReportingDashboard';
import Formulas from './Formulas';
import NotificationJobs from './NotificationJobs';
import ProductMatrix from './ProductMatrix';
import OpisPricing from './Reports';
import ReportsMonitoringForStationTank from './reports/MonitoringForStationTank';
import StationVolume from './reports/StationVolume';
import NewStationDashboard from './reports/NewStationDashboard';
import TotalVolume from './reports/TotalVolume';
import AddStation from './SaveStation';
import Stations from './Stations';
import Users from './Users';
// import Logistics from './Logistics';
import InvoiceSearch from './accounting/InvoiceSearch';
import AccountingReporting from './accounting/Reporting';
import SaveStationInvoice from './accounting/SaveStationInvoice';
import AccountingStationInvoices from './accounting/StationInvoices';
import AddBulkDeliveryBatch from './logistics/AddBulkDeliveryBatch';
import BulkCustomers from './logistics/BulkCustomers';
import BulkDeliveries from './logistics/BulkDeliveries';
import Carriers from './logistics/Carriers';
import LogisticsDeliveries from './logistics/Deliveries';
import LoadingAssignments from './logistics/LoadingAssignments';
import LogisticsMonitoring from './logistics/Monitoring';
import SaveBulkCustomer from './logistics/SaveBulkCustomer';
import SaveCarrier from './logistics/SaveCarrier';
import SaveDelivery from './logistics/SaveDelivery';
import SaveLoadingAssignment from './logistics/SaveLoadingAssignment';
import SaveSupplier from './logistics/SaveSupplier';
import SaveTerminal from './logistics/SaveTerminal';
import LogisticsInventory from './logistics/StationInventory';
import Suppliers from './logistics/Suppliers';
import Terminals from './logistics/Terminals';
import UpdateBulkDelivery from './logistics/UpdateBulkDelivery';
import Plugins from './Plugins';
import GasBuddyPrices from './reports/GasBuddyPrices';
import GasBuddyPricesForStation from './reports/GasBuddyPricesForStation';

import AccountingBulkInvoices from './accounting/BulkInvoices';
import RackTransfers from './accounting/RackTransfers';
import SearchRackTransfers from './accounting/RackTransferSearch';
import SaveBulkInvoice from './accounting/SaveBulkInvoice';
import SaveRackTransfer from './accounting/SaveRackTransfer';

import SaveTrueUpInvoice from './accounting/SaveTrueUpInvoice';
import AccountingTrueUpInvoices from './accounting/TrueUpInvoices';
import VendorBillSave from './billing/VendorBillSave';

import Accounting from './Accounting';
import BillingDashboard from './billing/BillingDashboard';
import QuickbooksMapping from './billing/QuickbooksMapping';
import VendorBills from './billing/VendorBills';
import LoadingAssignmentsAvailable from './logistics/LoadingAssignmentsAvailable';
import MissingBulkAr from './reconciliation/MissingBulkAr';
import MissingRackTransferAr from './reconciliation/MissingRackTransferAr';
import MissingStationAr from './reconciliation/MissingStationAr';

import FuelContracts from './inventory/FuelContracts';
import SaveFuelContract from './inventory/SaveFuelContract';
import SaveUser from './SaveUser';

import InventoryAllocations from './inventory/InventoryAllocations';
import InventoryDashboard from './inventory/InventoryDashboard';
import FuelForecast from './reports/FuelForecast';
import ReportsDashboard from './reports/ReportsDashboard';

import FreightProfitReportSearch from './inventory/FreightProfitSearch';
import InventoryAllocationDetails from './inventory/InventoryAllocationDetails';
import ProfitReportSearch from './inventory/ProfitReportSearch';
import SaveAdditionalFuelAllocation from './inventory/SaveAdditionalFuelAllocation';
import DeliveryActivityLogSearch from './logistics/DeliveryActivityLogSearch';
import DeliverySearch from './logistics/DeliverySearch';

import GenericSavingDialog from '../components/Dialogs/GenericSavingDialog';
import AddAndIgnoreRetailPricing from './retailPricing/AddAndIgnoreRetailPricing';
import ImportRetailPricing from './retailPricing/ImportRetailPricing';
import RetailManagementDashboard from './retailPricing/RetailManagementDashboard';
import RebateCampaigns from './rebateCampaigns/RebateCampaigns';
import SaveRebateCampaign from './rebateCampaigns/SaveRebateCampaign';

import OcrDashboard from './ocr/OcrDashboard';
import OcrGuides from './ocr/OcrGuides';
import OcrIngestionResults from './ocr/OcrIngestionResults';
import OcrIngestions from './ocr/OcrIngestions';
import OcrIngestionTriage from './ocr/OcrIngestionTriage';
import SaveOcrGuide from './ocr/SaveOcrGuide';

import ApAutomationDashboard from './apAutomation/ApAutomationDashboard';
import ApIngestionResults from './apAutomation/ApIngestionResults';
import ApIngestions from './apAutomation/ApIngestions';
import ApIngestionTriage from './apAutomation/ApIngestionTriage';
import ApProcessedEmails from './apAutomation/ApProcessedEmails';

import PricingRequests from './retailPricing/PricingRequests';
import PricingRequestTriage from './retailPricing/PricingRequestTriage';
import SalesExport from './reports/SalesExport';
import PlcChanges from './accounting/PlcChanges';
import QueuedVendorBills from './billing/QueuedVendorBills';
import QueuedVendorBillView from './billing/QueuedVendorBillView';
import GmAdderChanges from './accounting/GmAdderChanges';
import MhxBols from './billing/MhxBols';
import UsdgBols from './billing/UsdgBols';
import RailcarDashboard from './railcars/RailcarDashboard';
import RailcarListing from './railcars/RailcarListing';
import RailcarLinking from './railcars/RailcarLinking';
import RailcarMasterSheet from './railcars/RailcarMasterSheet';
import RailcarSearch from './railcars/RailcarSearch';
// import fmpNewBanner from '../images/fmp_new_banner.png';

const drawerWidth = 240;
const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			//overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		appFrame: {
			//position: 'relative',
			zIndex: 10,
			transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
		},
		drawerFrame: {
			zIndex: 1,
			display: 'flex',
			transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
		},
		appBar: {
			width: '100%',
			position: 'relative',
		},
		drawerPaper: {
			//position: 'relative',
			//height: 'auto',
			//width: drawerWidth,
			width: drawerWidth,
		},
		content: {
			display: 'flex',
			width: '100%',
			height: 'calc(100% - 56px)',
			//overflowX: 'scroll',
			paddingTop: theme.spacing(2),
			padding: theme.spacing(1),
			boxSizing: 'border-box',
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(2),
				height: 'calc(100% - 64px)',
			},
		},
		hide: {
			display: 'none',
		},
	};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL or contact dwp</h2>
	</div>
);

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			drawerOpen: false,
			isSuccessDialogOpen: false,
			isErrorDialogOpen: false,
		};
		this.handleSuccessClose = this.handleSuccessClose.bind(this);
	}

	componentDidMount() {
		const { width } = this.props;
		this.setState({ drawerOpen: isWidthUp('md', width) });
	}

	componentDidUpdate(prevProps) {
		if (this.props.width !== prevProps.width) {
			this.setState({ drawerOpen: isWidthUp('md', prevProps.width) });
		}
	}

	handleDrawerToggle() {
		this.setState({ drawerOpen: !this.state.drawerOpen });
	}

	handleSuccessClose() {
		const { clearSaving, clearSuccess, history, onSuccessRedirectTo } = this.props;
		clearSaving();
		clearSuccess();

		if (_.isFunction(onSuccessRedirectTo)) {
			onSuccessRedirectTo();
		} else {
			history.push(onSuccessRedirectTo);
		}
	}

	handleSavingClosed = () => {};

	continueSavingDialog = () => {
		const { clearSaving, history, onSuccessRedirectTo } = this.props;
		clearSaving();

		if (_.isFunction(onSuccessRedirectTo)) {
			onSuccessRedirectTo();
		} else {
			history.push(onSuccessRedirectTo);
		}
	};

	render() {
		// noinspection JSMismatchedCollectionQueryUpdate
		const {
			width,
			classes,
			savingStatus,
			savingMessage,
			successMessages = [],
			errorMessages = [],
			authUser,
		} = this.props;
		const { drawerOpen } = this.state;

		if (!authUser) {
			return null;
		}

		const styles = {
			header: {
				paddingLeft: drawerOpen ? drawerWidth : 0,
				// For April Fools
				// backgroundImage: `url('${fmpNewBanner}')`,
				// backgroundRepeat: 'repeat',
				// backgroundSize: '250px', // smaller size = more tiles
				// backgroundPosition: 'top left', // optional
			},
			container: {
				//margin: '80px 20px 20px 15px',
				paddingLeft: drawerOpen && isWidthUp('md', width) ? drawerWidth : 0,
			},
		};

		const isSavingOpen = !!savingStatus;
		const isSuccessDialogOpen = successMessages.length !== 0;
		const isErrorDialogOpen = errorMessages.length !== 0;

		let theDashboard;
		if (authUser && authUser.role === 'externalLogistics') {
			theDashboard = ExternalLogisticsDashboard;
		} else if (authUser && authUser.role === 'externalReporting') {
			theDashboard = ExternalReportingDashboard;
		} else {
			theDashboard = Dashboard;
		}

		return (
			<div className={classes.root}>
				<div className={classes.appFrame}>
					<AppBar className={classes.appBar} style={styles.header}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="open drawer"
								onClick={this.handleDrawerToggle.bind(this)}
							>
								<MenuIcon />
							</IconButton>

							<Typography
								variant="h6"
								color="inherit"
								noWrap
								style={{
									fontSize: 18,
									textShadow: '1px 1px 2px rgba(0,0,0,0.7)', // x, y, blur, color
								}}
							>
								FUEL MANAGEMENT PLATFORM
							</Typography>
						</Toolbar>
					</AppBar>
				</div>
				<div className={classes.drawerFrame} style={styles.container}>
					<LeftDrawer
						drawerOpen={drawerOpen}
						drawerPaper={classes.drawerPaper}
						logout={this.props.logout}
						authUser={this.props.authUser}
					/>
					<main className={classes.content}>
						<Switch>
							<Route exact path="/" component={theDashboard} />
							<Route exact path="/dashboard" component={theDashboard} />
							<Route exact path="/stations" component={Stations} />
							<Route exact path="/station/add" component={AddStation} />
							<Route exact path="/station/update/:stationId" component={AddStation} />
							<Route exact path="/notificationJobs" component={NotificationJobs} />
							<Route exact path="/notificationJob/add" component={AddNotificationJob} />
							<Route exact path="/notificationJob/update/:id" component={AddNotificationJob} />
							<Route exact path="/users" component={Users} />
							<Route exact path="/user/add" component={SaveUser} />
							<Route exact path="/user/update/:userId" component={SaveUser} />

							<Route exact path="/formulas" component={Formulas} />
							<Route exact path="/formulas/blends" component={Blends} />
							<Route exact path="/formulas/plcChanges" component={PlcChanges} />
							<Route exact path="/formulas/gmAdderChanges" component={GmAdderChanges} />
							<Route exact path="/invoiceProductMatrix" component={ProductMatrix} />

							<Route exact path="/reports" component={ReportsDashboard} />
							<Route exact path="/reports/opisPricing" component={OpisPricing} />
							<Route exact path="/reports/retailPrices" component={GasBuddyPrices} />
							<Route
								exact
								path="/reports/retailPricesForStation/:stationId"
								component={GasBuddyPricesForStation}
							/>
							<Route exact path="/reports/totalVolume" component={TotalVolume} />
							<Route exact path="/reports/stationVolume" component={StationVolume} />
							<Route exact path="/reports/newStationDashboard" component={NewStationDashboard} />
							<Route
								exact
								path="/reports/stationVolume/:stationId/:tankNumber"
								component={ReportsMonitoringForStationTank}
							/>
							<Route exact path="/reports/salesExport" component={SalesExport} />

							<Route exact path="/logistics" component={ExternalLogisticsDashboard} />
							<Route exact path="/reporting" component={ExternalReportingDashboard} />

							<Route exact path="/logistics/deliveries" component={LogisticsDeliveries} />
							<Route exact path="/logistics/stationDelivery/add" component={SaveDelivery} />
							<Route
								exact
								path="/logistics/stationDelivery/add/:stationId/:tankNumber/:productType"
								component={SaveDelivery}
							/>
							<Route
								exact
								path="/logistics/stationDelivery/update/:stationDeliveryId"
								component={SaveDelivery}
							/>

							<Route exact path="/logistics/monitoring" component={LogisticsMonitoring} />
							<Route exact path="/logistics/inventory/:lookBack?" component={LogisticsInventory} />

							<Route exact path="/logistics/carriers" component={Carriers} />
							<Route exact path="/logistics/carrier/add" component={SaveCarrier} />
							<Route exact path="/logistics/carrier/update/:carrierId" component={SaveCarrier} />

							<Route exact path="/logistics/terminals" component={Terminals} />
							<Route exact path="/logistics/terminal/add" component={SaveTerminal} />
							<Route exact path="/logistics/terminal/update/:terminalId" component={SaveTerminal} />

							<Route exact path="/logistics/suppliers" component={Suppliers} />
							<Route exact path="/logistics/supplier/add" component={SaveSupplier} />
							<Route exact path="/logistics/supplier/update/:supplierId" component={SaveSupplier} />

							<Route exact path="/logistics/loadingAssignments" component={LoadingAssignments} />
							<Route
								exact
								path="/logistics/loadingAssignment/add"
								component={SaveLoadingAssignment}
							/>
							<Route
								exact
								path="/logistics/loadingAssignment/showAvailable"
								component={LoadingAssignmentsAvailable}
							/>

							<Route exact path="/logistics/bulkCustomers" component={BulkCustomers} />
							<Route exact path="/logistics/bulkCustomer/add" component={SaveBulkCustomer} />
							<Route
								exact
								path="/logistics/bulkCustomer/update/:bulkCustomerId"
								component={SaveBulkCustomer}
							/>

							<Route exact path="/logistics/bulkDeliveries" component={BulkDeliveries} />
							<Route exact path="/logistics/bulkDelivery/add" component={AddBulkDeliveryBatch} />
							<Route
								exact
								path="/logistics/bulkDelivery/update/:bulkDeliveryId"
								component={UpdateBulkDelivery}
							/>

							<Route exact path="/plugins" component={Plugins} />

							<Route exact path="/accounting" component={Accounting} />
							<Route
								exact
								path="/accounting/stationInvoices"
								component={AccountingStationInvoices}
							/>
							<Route
								exact
								path="/accounting/stationInvoices/:startingTab"
								component={AccountingStationInvoices}
							/>
							<Route exact path="/accounting/stationInvoice/add" component={SaveStationInvoice} />
							<Route
								exact
								path="/accounting/stationInvoice/update/:stationInvoiceId"
								component={SaveStationInvoice}
							/>

							<Route exact path="/accounting/bulkInvoices" component={AccountingBulkInvoices} />
							<Route
								exact
								path="/accounting/bulkInvoices/:startingTab"
								component={AccountingBulkInvoices}
							/>

							{/** RACK TRANSFER */}
							<Route exact path="/accounting/rackTransfers" component={RackTransfers} />
							<Route
								exact
								path="/accounting/rackTransfers/:startingTab"
								component={RackTransfers}
							/>
							<Route
								exact
								path="/accounting/rackTransfer/update/:rackTransferId"
								component={SaveRackTransfer}
							/>
							<Route exact path="/accounting/rackTransferSearch" component={SearchRackTransfers} />

							<Route exact path="/accounting/bulkInvoice/add" component={SaveBulkInvoice} />
							<Route
								exact
								path="/accounting/bulkInvoice/update/:bulkInvoiceId"
								component={SaveBulkInvoice}
							/>

							<Route exact path="/accounting/trueUpInvoices" component={AccountingTrueUpInvoices} />
							<Route
								exact
								path="/accounting/trueUpInvoices/:startingTab"
								component={AccountingTrueUpInvoices}
							/>
							<Route exact path="/accounting/trueUpInvoice/add" component={SaveTrueUpInvoice} />
							<Route
								exact
								path="/accounting/trueUpInvoice/update/:trueUpInvoiceId"
								component={SaveTrueUpInvoice}
							/>

							<Route exact path="/accounting/reporting" component={AccountingReporting} />
							<Route exact path="/accounting/invoiceSearch" component={InvoiceSearch} />

							<Route exact path="/billing" component={BillingDashboard} />
							<Route exact path="/billing/vendorBills" component={VendorBills} />
							<Route exact path="/billing/queuedVendorBills" component={QueuedVendorBills} />
							<Route exact path="/accounting/mhxBols" component={MhxBols} />
							<Route exact path="/accounting/usdgBols" component={UsdgBols} />
							<Route
								exact
								path="/billing/queuedVendorBill/:action(view)/:queuedVendorBillId?"
								component={QueuedVendorBillView}
							/>

							<Route
								exact
								path="/billing/vendorBill/:action(add|update)/:vendorBillId?"
								component={VendorBillSave}
							/>
							<Route exact path="/billing/quickbooksMapping" component={QuickbooksMapping} />

							<Route exact path="/reconciliation" component={BillingDashboard} />
							<Route exact path="/reconciliation/missingStationAr" component={MissingStationAr} />
							<Route exact path="/reconciliation/missingBulkAr" component={MissingBulkAr} />
							<Route
								exact
								path="/reconciliation/missingRackTransferAr"
								component={MissingRackTransferAr}
							/>

							<Route exact path="/inventoryManagement" component={InventoryDashboard} />
							<Route exact path="/inventoryManagement/fuelContracts" component={FuelContracts} />
							<Route
								exact
								path="/inventoryManagement/fuelContract/add"
								component={SaveFuelContract}
							/>
							<Route
								exact
								path="/inventoryManagement/fuelContract/update/:fuelContractId"
								component={SaveFuelContract}
							/>

							<Route
								exact
								path="/reports/fuelForecast/:specialEvents?/:customer?/:region?"
								component={FuelForecast}
							/>

							<Route exact path="/ocr/ocrGuides" component={OcrGuides} />
							<Route
								exact
								path="/ocr/ocrGuide/:action(add|update)/:ocrGuideId?"
								component={SaveOcrGuide}
							/>

							<Route exact path="/ocr" component={OcrDashboard} />
							<Route exact path="/ocr/ocrIngestions" component={OcrIngestions} />
							<Route exact path="/ocr/ocrIngestionResults" component={OcrIngestionResults} />
							<Route
								exact
								path="/ocr/ocrIngestionResult/triage/:ocrIngestionResultId?"
								component={OcrIngestionTriage}
							/>

							<Route
								exact
								path="/inventoryManagement/inventoryAllocations/:yearMonth?"
								component={InventoryAllocations}
							/>
							<Route
								exact
								path="/inventoryManagement/inventoryAllocation/details/:inventoryAllocationId/:yearMonth?"
								component={InventoryAllocationDetails}
							/>

							<Route
								exact
								path="/inventoryManagement/additionalFuelAllocation/add/:fuelContractId?"
								component={SaveAdditionalFuelAllocation}
							/>
							<Route
								exact
								path="/inventoryManagement/additionalFuelAllocation/update/:additionalFuelAllocationId?"
								component={SaveAdditionalFuelAllocation}
							/>

							<Route
								exact
								path="/inventoryManagement/profitReports"
								component={ProfitReportSearch}
							/>
							<Route
								exact
								path="/inventoryManagement/freightReports"
								component={FreightProfitReportSearch}
							/>

							<Route exact path="/logistics/deliverySearch" component={DeliverySearch} />
							<Route
								exact
								path="/logistics/activityLogSearch"
								component={DeliveryActivityLogSearch}
							/>

							<Route exact path="/retailPricing" component={RetailManagementDashboard} />
							<Route exact path="/retailPricing/import" component={ImportRetailPricing} />
							<Route exact path="/retailPricing/addIgnore" component={AddAndIgnoreRetailPricing} />
							<Route exact path="/retailPricing/pricingRequests" component={PricingRequests} />
							<Route
								exact
								path="/retailPricing/triagePricingRequest/:pricingRequestId"
								component={PricingRequestTriage}
							/>

							<Route exact path="/rebateCampaign/rebateCampaigns" component={RebateCampaigns} />
							<Route exact path="/rebateCampaign/add" component={SaveRebateCampaign} />

							<Route
								exact
								path="/rebateCampaign/update/:rebateCampaignId"
								component={SaveRebateCampaign}
							/>

							<Route exact path="/apAutomation" component={ApAutomationDashboard} />
							<Route exact path="/apAutomation/apProcessedEmails" component={ApProcessedEmails} />
							<Route exact path="/apAutomation/apIngestions" component={ApIngestions} />
							<Route exact path="/apAutomation/apIngestionResults" component={ApIngestionResults} />
							<Route
								exact
								path="/apAutomation/apIngestionResult/triage/:apIngestionResultId?"
								component={ApIngestionTriage}
							/>

							<Route exact path="/railcars" component={RailcarDashboard} />
							<Route exact path="/railcars/listing" component={RailcarListing} />
							<Route exact path="/railcars/linking" component={RailcarLinking} />
							<Route
								exact
								path="/railcars/masterSheet/:filterByRailcarNumber?/:filterByTerminalId?"
								component={RailcarMasterSheet}
							/>
							<Route exact path="/railcars/export" component={RailcarSearch} />

							<Route component={NoMatch} />
						</Switch>
					</main>
				</div>

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>

				<SuccessDialog
					onClose={this.handleSuccessClose}
					successMessages={successMessages}
					open={isSuccessDialogOpen}
				/>

				<GenericSavingDialog
					open={isSavingOpen}
					onClose={this.handleSavingClosed}
					onContinue={this.continueSavingDialog}
					processingText={savingMessage}
					status={savingStatus}
				/>
			</div>
		);
	}
}

Layout.propTypes = {
	classes: PropTypes.object.isRequired,
	logout: PropTypes.func.isRequired,
	width: PropTypes.string,
	onSuccessRedirectTo: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	savingStatus: PropTypes.string,
	savingMessage: PropTypes.string,
	successMessages: PropTypes.array,
	errorMessages: PropTypes.array,
	clearError: PropTypes.func,
	clearSaving: PropTypes.func,
	clearSuccess: PropTypes.func,
	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), withWidth(), LayoutContainer])(Layout);
